import React, { useState } from "react";
import { useSpring, animated, easings } from "react-spring";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'
import "../componentsStyle.css"
import "./packs.css"
import Regenerate from "../Regenerate/Regenerate";

const PdmPacks = (props) => {
  const { showMaximumChat, data, updateMessage, setIsFeedbackPop, index, messages, loading, sessionId, checkThumsDownFeedback } = props
  const [toggleListIcons, setToggleListIcons] = useState({});

  const fadeInProps = useSpring({
    from: { opacity: Math.random() },
    to: { opacity: 1 },
    config: { duration: 1000, easing: easings.easeInOut },
    // Adjust duration and easing as needed
  });

  const handleToggle = (index) => {
    setToggleListIcons((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const showPacksMin = (pack) => {
    return (
      <div style={{ width: '100%' }}>
        <p className="channel-list-heading">{pack?.pack_name || pack?.channel_name}</p>
        <div style={{ display: !showMaximumChat && 'flex', width: '100%' }}>
          {!showMaximumChat && <span style={{ width: '50%' }} className="channel-list-count">{pack?.Channel_Count} Channels</span>}
          {<div style={{ width: '50%', color: '#d02f92' }} className="channel-list-count">₹ {pack?.Price}</div>}
        </div>

      </div>
    )
  }

  const showPacksMax = (pack) => {
    return (

      <div style={{ width: '75%', gap: '5%' }} className={showMaximumChat && "price_css"}>
        <p style={{ width: '40%' }} className="channel-list-heading">{pack?.pack_name || pack?.channel_name}</p>
        <div style={{ display: !showMaximumChat && 'flex' }}>
          {!showMaximumChat && <span className="channel-list-count">{pack?.Channel_Count} Channels</span>}
          {<div style={{ marginLeft: '40px', color: '#d02f92' }} className="channel-list-count">₹ {pack?.Price}</div>}
        </div>

      </div>
    )
  }


  const renderList = (msg) => {
    const data = msg?.llm_response[0]?.pdm_output;
    const firstColumnWidth = showMaximumChat ? '35%' : '50%';
    const otherColumnWidth = showMaximumChat ? '20%' : '30%';

    const formatHeader = (header) => {
      return header.replace('NUMBER', 'No.').replace(/_/g, ' ');
    };

    const getPadding = (isToggled) => {
      if (showMaximumChat) {
        return isToggled ? '16px 16px 0px 16px' : '16px';
      } else {
        return isToggled ? '8px 16px 0px 16px' : '8px 16px';
      }
    };


    return (
      <div className="channel-list">
        {data && data.map((pack, index) => {
          const isToggled = toggleListIcons[index];
          const channelKeys = pack.Channels.length > 0 ? Object.keys(pack.Channels[0]) : [];
          const visibleChannelKeys = showMaximumChat ? channelKeys : channelKeys.slice(0, 3);

          return (
            <div key={index}>
              <div
                style={{
                  height: showMaximumChat && '28px',
                  borderRadius: isToggled ? '8px 8px 0px 0px' : '8px',
                  marginBottom: !isToggled && '16px',
                  padding: getPadding(isToggled),
                  cursor: 'pointer',
                }}
                className={`channel-list-head ${isToggled ? "no-hover" : "hover-pop"}`}
                onClick={() => handleToggle(index)}
              >
                {showMaximumChat ? showPacksMax(pack) : showPacksMin(pack)}
                <div style={{ display: 'flex', gap: '4px' }}>
                  {showMaximumChat && (
                    <span style={{ fontWeight: '700' }} className="channel-list-count">
                      {pack.Channel_Count} Channels
                    </span>
                  )}
                  <img
                    style={{
                      height: '26px',
                      width: '24px',
                      top: showMaximumChat ? '' : '-15px',
                      position: 'relative',
                    }}
                    key={'plus'}
                    src={isToggled ? iconMinus : iconPlus}
                  />
                </div>
              </div>
              {isToggled && (
                <div className="list-of-channels">
                  <div style={{ marginTop: '10px', marginBottom: '14px' }}>
                    {pack?.Seiebel_Name && <div> <strong>Siebel Name :</strong> {pack?.Seiebel_Name}</div>}
                    {pack?.DBR !== null && pack?.DBR !== undefined && (
                      <div style={{ marginTop: '6px' }}>
                        <strong>DBR:</strong> {pack.DBR}
                      </div>
                    )}

                    {pack?.Channel_Type && <div style={{marginTop : '6px'}}><strong> Channel Type :</strong> {pack?.Channel_Type}</div> }
                    {pack?.Pack_UOM && <div style={{marginTop : '6px'}}><strong> Pack UOM :</strong> {pack?.Pack_UOM}</div> }
                  </div>
                  <div
                    style={{
                      border: '1px solid #575757',
                      padding: '6px',
                      borderRadius: '6px',
                    }}
                  >
                    <table>
                      <thead>
                        <tr style={{ display: 'flex', marginBottom: '8px' }}>
                          {visibleChannelKeys.map((key, i) => (
                            <th
                              key={i}
                              className="coloum-name"
                              style={{
                                width: i === 0 ? firstColumnWidth : otherColumnWidth,
                              }}
                            >
                              {formatHeader(key)}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody style={{ gap: '8px', display: 'grid' }}>
                        {pack.Channels.map((channel, i) => (
                          <tr key={i} style={{ display: 'flex' }}>
                            {visibleChannelKeys.map((key, j) => (
                              <td
                                key={j}
                                className="coloum-details"
                                style={{
                                  width: j === 0 ? firstColumnWidth : otherColumnWidth,
                                }}
                              >
                                {channel[key]}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          );
        })}


        <div style={{ marginTop: '20px', marginLeft: '10px', display: 'grid' }}>
          <span className="sources-text">Sources</span>
          <span className="sources-text" style={{ fontWeight: '300' }}>For pack/channels related data, source won't be referenced</span>
        </div>

      </div>
    );
  };


  return (
    <div className="server-text-response-body">

      <div style={{ fontWeight: '600' }} className="channel-list-count"> Note: For any quarterly/annual packs, please check the subscriber eligibility in SIEBEL and use the SIEBEL Catalogue for the pack addition.</div>
      <div className="channel-list-reponse" style={{ color: '#220046', marginTop: '14px' }}>{data?.llm_response[0]?.Text}</div>
      {renderList(data)}
      {/* <Regenerate msg={data} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} index={index} messages={messages} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} /> */}
    </div>
  )
}

export default PdmPacks
